import { Link } from '@tanstack/react-router'
import { Button } from '@/components/ui/Controls'

export function FinalCTA() {
  return (
    <section className="py-32 bg-ground relative overflow-hidden">
      {/* Subtle background glow */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[600px] h-[600px] bg-primary/10 rounded-full blur-[100px] opacity-50" />
      </div>

      <div className="mx-auto max-w-4xl px-4 sm:px-6 relative z-10 text-center">
        <h2 className="text-4xl sm:text-5xl md:text-6xl font-semibold text-ink tracking-tight mb-6">
          Give your GitHub an AI control layer.
        </h2>
        <p className="text-xl text-ink-muted leading-relaxed mb-10 max-w-2xl mx-auto">
          Real repository access. Human approval. Complete visibility.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/signin" className="w-full sm:w-auto">
            <Button variant="primary" className="w-full sm:w-auto px-8 py-4 text-lg h-14 shadow-pop hover:shadow-primary/30 transition-all font-medium">
              Start building for free
            </Button>
          </Link>
          <Link to="/pricing" className="w-full sm:w-auto">
            <Button className="w-full sm:w-auto px-8 py-4 text-lg h-14 bg-surface hover:bg-raised transition-colors font-medium">
              View pricing
            </Button>
          </Link>
        </div>
      </div>
    </section>
  )
}
